import i18n from "i18next";
import translate_en from "./translate-en";
import translate_fr from "./translate-fr";
import LngDetector from "i18next-browser-languagedetector";

const lngDetector = new LngDetector();

i18n.use(lngDetector).init({
    detection: { lookupCookie: 'language' },
    /* Change value to switch between the two languages. Only for local dev testing, shouldn't be deployed.
     lng: "fr",    
    lng: "en",
    */
    fallbackLng: "en",
    resources: {
        en: { translate: translate_en },
        fr: { translate: translate_fr }
    },
    debug: false,
    ns: ["translate"],
    defaultNS: "translate"
});

export default i18n;

